import { jobWorkItemSlipAddApi } from "src/domain/api/jobWorkItem/slip/jobWorkItemSlipAddApi"

type PayloadShape = Parameters<typeof jobWorkItemSlipAddApi>[0]

export async function jobWorkItemSlipAddService(payload: PayloadShape, token: string) {
	// if (_.isEmpty(payload.note)) payload.note = undefined
	return await jobWorkItemSlipAddApi(payload, token)
}
